import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const StyledPostCard = styled.div`
  /* width: 100%; */
  max-width: 500px;
  /* height: 100px; */
  margin: 20px auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  border: gray 1px solid;
  border-radius: 5px;
  background: #233140;
`

const CardTitle = styled.h2`
  font-size: 1.1rem;
  margin: 5px 10px;
  /* padding: 0; */
`

const CardInfo = styled.div`
  font-size: 1rem;
  margin: 5px 10px;
  /* padding: 0; */
`

const CardDate = styled.span`
  font-size: 1rem;
  margin: 0 10px 0 0;
  color: gray;
`

const CardCategory = styled.span`
  font-size: 1rem;
  margin: 0 10px 0 0;
  text-transform: capitalize;
  display: inline-block !important;
`

const PostCard = ({ node }) => {
  const { title, date, category } = node.frontmatter
  const slug = node.fields.slug

  return (
    <Link to={slug}>
      <StyledPostCard>
        <CardTitle>{title}</CardTitle>
        <CardInfo>
          <CardDate>{date}</CardDate>
          <CardCategory>{category}</CardCategory>
        </CardInfo>
      </StyledPostCard>
    </Link>
  )
}

export default PostCard
